import React from 'react'
import { observer } from 'mobx-react'
import { GeoJSON, LayerGroup } from 'react-leaflet'
import IconMarker from './IconMarker'

// Renders a buffer around a point while its being edited
const IsochroneLayer = ({ isochrone }) => (
  <LayerGroup>
    {
      isochrone.position.latLng !== null
        ? (
          <IconMarker
            icon='draw-handle'
            position={isochrone.position.latLng}
            onDragEnd={(latLng) => {
              isochrone.position.latLng = latLng
            }}
            className='draw-handle focused'
            draggable
          />
          )
        : null
    }
    {
      isochrone.region
        ? (
          <GeoJSON
            color={isochrone.getColor}
            key={JSON.stringify(isochrone.region)}
            data={isochrone.region}
            className='region-buffer region-buffer-user-drawn'
            fillOpacity='1'
          />
          )
        : null
    }
  </LayerGroup>
)

export default observer(IsochroneLayer)
